'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _assertThisInitialized = require('@babel/runtime/helpers/assertThisInitialized');
var _inheritsLoose = require('@babel/runtime/helpers/inheritsLoose');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var bumbag = require('bumbag');
var Transactions_components_consumer_Totals = require('./Totals.js');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var faChevronDown = require('@fortawesome/pro-solid-svg-icons/faChevronDown');
var faChevronUp = require('@fortawesome/pro-solid-svg-icons/faChevronUp');
require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
require('lodash/capitalize');
require('lodash/get');
require('date-fns/format');
require('date-fns/parseISO');
require('@medipass/utils/constants');
require('@medipass/utils/claim-payment-status-icons');
require('@medipass/utils/claim-payment-status-text-classes');
require('@medipass/utils/claim-payment-status-formatted');
require('@medipass/utils/funders');
require('@medipass/utils/transaction-status');
require('./RefundReferenceList.js');
require('../../../components/DescriptionLabel.js');
require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
require('@fortawesome/pro-solid-svg-icons/faEyeSlash');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ServiceItemDetails = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose__default["default"](ServiceItemDetails, _React$PureComponent);

  function ServiceItemDetails() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "state", {
      showPaymentDetails: false
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "handleShowPaymentDetail", function () {
      var showPaymentDetails = _this.state.showPaymentDetails;

      _this.setState({
        showPaymentDetails: !showPaymentDetails
      });
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "render", function () {
      var _this$props = _this.props,
          funderCode = _this$props.funderCode,
          isPreview = _this$props.isPreview,
          serviceItems = _this$props.serviceItems,
          isQuote = _this$props.isQuote,
          totalType = _this$props.totalType,
          transaction = _this$props.transaction;
      var showPaymentDetails = _this.state.showPaymentDetails;
      return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
        textAlign: "center"
      }, /*#__PURE__*/React__default["default"].createElement(bumbag.Button, {
        palette: "secondary",
        variant: "ghost",
        onClick: _this.handleShowPaymentDetail
      }, showPaymentDetails ? "Hide " + (isQuote ? 'quote' : 'payment') + " details" : "Show " + (isQuote ? 'quote' : 'payment') + " details", /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: showPaymentDetails ? faChevronUp.faChevronUp : faChevronDown.faChevronDown,
        className: "ml-2"
      }))), showPaymentDetails && /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, serviceItems.map(function (item, i) {
        return (
          /*#__PURE__*/

          /* eslint-disable react/no-array-index-key */
          React__default["default"].createElement("div", {
            key: i,
            className: "flex flex-col bg-white p-6 shadow-tyro"
          }, /*#__PURE__*/React__default["default"].createElement(Transactions_components_consumer_Totals["default"], {
            funderCode: funderCode,
            isPreview: isPreview,
            serviceItem: item,
            totalType: totalType,
            transaction: transaction
          }))
        );
      })));
    });

    return _this;
  }

  return ServiceItemDetails;
}(React__default["default"].PureComponent);

_defineProperty__default["default"](ServiceItemDetails, "defaultProps", {
  funderCode: undefined,
  isPreview: false,
  isQuote: false,
  totalType: 'out-of-pocket',
  transaction: undefined
});

exports["default"] = ServiceItemDetails;
